// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"783":"5e0ebfdb","1841":"4f8c4484"}[chunkId] + ".css";
};